import { Flex, Layout, Menu, theme } from 'antd'
import { useTranslation } from 'react-i18next'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { BrandLogo } from '@/shared/ui/BrandLogo'
import { LanguageSwitcher } from '@/shared/ui/LanguageSwitcher'
import { ThemeToggle } from '@/shared/ui/ThemeToggle'
import { NAV_ITEMS, findActiveNavKey } from './navItems'
import { ProfileMenu } from './ProfileMenu'

/**
 * Header — desktop'da to'liq navigatsiya bilan (mobil pastki tab-bar
 * ishlatgani uchun bu yerda takrorlanmaydi), telefonda faqat brend va
 * harakatlar.
 *
 * Hisob amallari (kim bo'lib kirilgan, parolni almashtirish, chiqish) bosh
 * navigatsiyada ALOHIDA bo'lim EMAS — bor-yo'g'i besh nav bo'limi bor
 * (vazifa hujjati), shuning uchun ular `ProfileMenu` ichida.
 *
 * ⚠️ XSB-008 — «profil ikonkasi menyu ochmaydi». HAQIQIY dropdown menyu
 * qo'shildi (egasi qarori, 2026-08-13). Nima kirgani va nega —
 * `ProfileMenu.tsx` izohida. Chiqishning alohida ikonkasi O'SHA YERGA
 * ko'chdi, bu yerda endi yo'q.
 *
 * ⚠️ Til va mavzu tanlagichlari ATAYLAB menyuga ko'chirilmadi va ochiq
 * turibdi — sababi ham `ProfileMenu.tsx` da.
 *
 * ⚠️ Tugmalarning bosish maydoni `styles/global.css` da (44px) —
 * o'sha izohda o'lchangan sonlar bor.
 */
export function AppHeader({ isMobile }: { isMobile: boolean }) {
  const { t } = useTranslation()
  const { token } = theme.useToken()
  const location = useLocation()
  const navigate = useNavigate()

  const activeKey = findActiveNavKey(location.pathname)

  return (
    <Layout.Header
      className="xsib-header"
      style={{
        background: token.colorBgContainer,
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        padding: isMobile ? '0 12px' : '0 24px',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        height: 56,
        lineHeight: '56px',
      }}
    >
      <Link to="/" style={{ display: 'flex', alignItems: 'center', minHeight: 44, flexShrink: 0 }}>
        <BrandLogo height={isMobile ? 24 : 28} label={t('app.name')} />
      </Link>

      {!isMobile && (
        <Menu
          mode="horizontal"
          selectedKeys={[activeKey]}
          items={NAV_ITEMS.map((item) => ({
            key: item.key,
            icon: item.icon,
            label: t(item.labelKey),
          }))}
          onClick={({ key }) => {
            const item = NAV_ITEMS.find((n) => n.key === key)
            if (item) navigate(item.path)
          }}
          style={{ flex: 1, minWidth: 0, borderBottom: 'none' }}
        />
      )}

      <Flex align="center" gap={4} style={{ marginInlineStart: isMobile ? 'auto' : 0 }}>
        <LanguageSwitcher />
        <ThemeToggle />
        <ProfileMenu />
      </Flex>
    </Layout.Header>
  )
}
